export function clean(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => !!v))
}

export function deleteProps(target) {
    Object.keys(target).forEach((k) => delete target[k])
}
